import { faUser as fasUser } from '@fortawesome/free-solid-svg-icons/faUser'

import { faSpinner as falSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner'
import { faTrash as falTrash } from '@fortawesome/free-solid-svg-icons/faTrash'
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons/faThumbsUp'
import { faChevronCircleLeft as falChevronCircleLeft } from '@fortawesome/free-solid-svg-icons/faChevronCircleLeft'
import { faHome as falHome } from '@fortawesome/free-solid-svg-icons/faHome'
import { faBars as falBars } from '@fortawesome/free-solid-svg-icons/faBars'
import { faSignOutAlt as falSignOutAlt } from '@fortawesome/free-solid-svg-icons/faSignOutAlt'
import { faBuilding as falBuilding } from '@fortawesome/free-solid-svg-icons/faBuilding'
import { faUsers as falUsers } from '@fortawesome/free-solid-svg-icons/faUsers'
import { faUserCircle as falUserCircle } from '@fortawesome/free-solid-svg-icons/faUserCircle'
import { faSlidersH as falSlidersV } from '@fortawesome/free-solid-svg-icons/faSlidersH'
import { faChartPie as falChartPie } from '@fortawesome/free-solid-svg-icons/faChartPie'
import { faCog as falCog } from '@fortawesome/free-solid-svg-icons/faCog'
import { faHistory as falHistory } from '@fortawesome/free-solid-svg-icons/faHistory'
// import { faFileChartLine as falFileChartLine } from '@fortawesome/free-solid-svg-icons/faFileChartLine'
import { faChartBar as falChartBar } from '@fortawesome/free-solid-svg-icons/faChartBar'
import { faPuzzlePiece as falPuzzlePiece } from '@fortawesome/free-solid-svg-icons/faPuzzlePiece'
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle'
import { faEnvelope as falEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle'
import { faFileInvoiceDollar as falFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons/faFileInvoiceDollar'
import { faTimesCircle as falTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle'
import { faUsersCog as falUsersCog } from '@fortawesome/free-solid-svg-icons/faUsersCog'
import { faMinusCircle as falMinusCircle } from '@fortawesome/free-solid-svg-icons/faMinusCircle'
import { faTimes as falTimes } from '@fortawesome/free-solid-svg-icons/faTimes'
import { faBoxes as falBoxes } from '@fortawesome/free-solid-svg-icons/faBoxes'
import { faWarehouse as falWarehouse } from '@fortawesome/free-solid-svg-icons/faWarehouse'
import { faIdCard as falIdCard } from '@fortawesome/free-solid-svg-icons/faIdCard'
import { faShoppingBag as falShoppingBag } from '@fortawesome/free-solid-svg-icons/faShoppingBag'
import { faShoppingCart as falShoppingCart } from '@fortawesome/free-solid-svg-icons/faShoppingCart'
import { faPlus as falPlus } from '@fortawesome/free-solid-svg-icons/faPlus'
import { faPlusSquare as falPlusSquare } from '@fortawesome/free-solid-svg-icons/faPlusSquare'
import { faCashRegister as falCashRegister } from '@fortawesome/free-solid-svg-icons/faCashRegister'
import { faSave as falSave } from '@fortawesome/free-solid-svg-icons/faSave'
import { faMoneyCheckAlt as falMoneyCheckAlt } from '@fortawesome/free-solid-svg-icons/faMoneyCheckAlt'
import { faStoreAltSlash as falStoreAltSlash } from '@fortawesome/free-solid-svg-icons/faStoreAltSlash'
import { faStore as falStore } from '@fortawesome/free-solid-svg-icons/faStore'
import { faCopy as falCopy } from '@fortawesome/free-solid-svg-icons/faCopy'
import { faSortAmountDown as falSortAmountDown } from '@fortawesome/free-solid-svg-icons/faSortAmountDown'
import { faBinoculars as falBinoculars } from '@fortawesome/free-solid-svg-icons/faBinoculars'
import { faTshirt } from '@fortawesome/free-solid-svg-icons/faTshirt'
import { faShoePrints } from '@fortawesome/free-solid-svg-icons/faShoePrints'
import { faDollarSign as falDollarSign } from '@fortawesome/free-solid-svg-icons/faDollarSign'
import { faFunnelDollar as falFunnelDollar } from '@fortawesome/free-solid-svg-icons/faFunnelDollar'
import { faUserAstronaut as falUserAstronaut } from '@fortawesome/free-solid-svg-icons/faUserAstronaut'
import { faBoxOpen as falBoxOpen } from '@fortawesome/free-solid-svg-icons/faBoxOpen'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons/faPencilAlt'
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash'
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye'
import { faSkullCrossbones } from '@fortawesome/free-solid-svg-icons/faSkullCrossbones'
import { faUndoAlt } from '@fortawesome/free-solid-svg-icons/faUndoAlt'
import { faHandScissors } from '@fortawesome/free-solid-svg-icons/faHandScissors'
import { faBookDead } from '@fortawesome/free-solid-svg-icons/faBookDead'
import { faTicketAlt } from '@fortawesome/free-solid-svg-icons/faTicketAlt'
import { faPrint } from '@fortawesome/free-solid-svg-icons/faPrint'
import { faPen } from '@fortawesome/free-solid-svg-icons/faPen'
import { faCalendar } from '@fortawesome/free-solid-svg-icons/faCalendar'
import { faArrowsAlt } from '@fortawesome/free-solid-svg-icons/faArrowsAlt'
import { faWrench } from '@fortawesome/free-solid-svg-icons/faWrench'

export default {
  falSpinner,
  falUsers,
  falSlidersV,
  fasUser,
  falTrash,
  faThumbsUp,
  falChevronCircleLeft,
  falHome,
  falBars,
  falSignOutAlt,
  falBuilding,
  falChartPie,
  falCog,
  falHistory,
  falUserCircle,
  falChartBar,
  falPuzzlePiece,
  faCheck,
  faExclamationTriangle,
  falEnvelope,
  falFileInvoiceDollar,
  falTimesCircle,
  falUsersCog,
  falMinusCircle,
  falTimes,
  falWarehouse,
  falIdCard,
  falShoppingBag,
  falShoppingCart,
  falPlus,
  falCashRegister,
  falSave,
  falMoneyCheckAlt,
  falPlusSquare,
  falStoreAltSlash,
  falStore,
  falCopy,
  falSortAmountDown,
  falBinoculars,
  faTshirt,
  falDollarSign,
  falFunnelDollar,
  falBoxes,
  falUserAstronaut,
  faInfoCircle,
  falBoxOpen,
  faPencilAlt,
  faEyeSlash,
  faSkullCrossbones,
  faUndoAlt,
  faHandScissors,
  faBookDead,
  faTicketAlt,
  faPrint,
  faEye,
  faPen,
  faCalendar,
  faArrowsAlt,
  faWrench,
  faShoePrints
}
